import { render } from "./TrxEnergyPlatform.vue?vue&type=template&id=1853a390&scoped=true"
import script from "./TrxEnergyPlatform.vue?vue&type=script&lang=js"
export * from "./TrxEnergyPlatform.vue?vue&type=script&lang=js"

import "./TrxEnergyPlatform.vue?vue&type=style&index=0&id=1853a390&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1853a390"]])

export default __exports__